class SwiftBank {
  bankName: string;

  constructor(bankName: string) {
    this.bankName = bankName;
  }
}

export { SwiftBank };
